import React from 'react';
import { FormattedMessage } from 'react-intl';

import { translations } from '@/locale';

import Table from '@flyblack/common/components/Table';
import Typography from '@flyblack/common/components/Typography';

export interface Props {}

const CharterEnquireTableHeader: React.FC<Props> = () => {
  const text = translations.pages.charterEnquire.table.header;

  return (
    <Typography is={Table.Header} type="hummingbird" className="uppercase text-opacity-[64%] px-10 justify-between">
      <Table.Data className="pr-1 w-[15%]" header>
        <FormattedMessage id={text.firstName} />
      </Table.Data>

      <Table.Data className="pr-1 w-[15%]" header>
        <FormattedMessage id={text.lastName} />
      </Table.Data>

      <Table.Data className="pr-1 w-[20%]" header>
        <FormattedMessage id={text.email} />
      </Table.Data>

      <Table.Data className="pr-1 w-[15%]" header>
        <FormattedMessage id={text.phone} />
      </Table.Data>

      <Table.Data className="pr-1 w-[10%]" header>
        <FormattedMessage id={text.date} />
      </Table.Data>

      <Table.Data className="pr-1 w-[10%]" header>
        <FormattedMessage id={text.departure} />
      </Table.Data>

      <Table.Data className="pr-1 w-[10%]" header>
        <FormattedMessage id={text.arrival} />
      </Table.Data>

      <Table.Data className="pr-1 w-24" header>
        <FormattedMessage id={text.price} />
      </Table.Data>

      <Table.Data className="pr-1 w-24" header>
        <FormattedMessage id={text.multiLeg} />
      </Table.Data>

      <Table.Data className="pr-1 w-[160px] justify-end" header>
        <FormattedMessage id={text.status} />
      </Table.Data>

      <Table.Data className="w-4" header />
    </Typography>
  );
};

export default CharterEnquireTableHeader;
